import { useSelector } from 'react-redux';

import Modal from '@anwb/poncho/components/modal';
import {
	defaultUpgradeSelector,
	leaseCarDataNameSelector,
	leaseCarUpgradesSelector,
} from 'store/selectors';
import { StandardEquipment, Upgrade } from 'types';

import { getEquipmentModalABTest } from '../../../../utils/getEquipmentModalABTest';
import { getComparingUpgrade } from '../utils';
import { getUniqueStandardEquipments } from '../utils/getUniqueStandardEquipments';

import { EquipmentContent } from './EquipmentContent';
import { EquipmentContentV2 } from './EquipmentContentV2';

type StandardEquipmentProps = {
	onOpen: (isOpen: boolean) => void;
	upgrade: Upgrade;
	open: boolean;
};

export const StandardEquipmentModal = ({ onOpen, upgrade, open }: StandardEquipmentProps) => {
	const equipmentModalABTest: string | false = getEquipmentModalABTest();
	const upgrades: Upgrade[] = useSelector(leaseCarUpgradesSelector);
	const basicUpgrade: Upgrade = useSelector(defaultUpgradeSelector);
	const comparingTo: Upgrade = getComparingUpgrade(upgrades, upgrade, basicUpgrade);
	const leaseCarApiCarName = useSelector(leaseCarDataNameSelector);
	const modalTitle: string = equipmentModalABTest
		? `Uitrusting ${leaseCarApiCarName}`
		: `Uitvoering ${upgrade.description}`;

	const standardEquipmentList: StandardEquipment[] = upgrade.monthPrice
		? getUniqueStandardEquipments(
				comparingTo.vehicleData.standardEquipment, // cheaper variant or baseUpgrade
				upgrade.vehicleData.standardEquipment
			)
		: basicUpgrade.vehicleData.standardEquipment;

	return (
		<Modal
			data-test="standard-equipment-modal"
			open={open}
			size="l"
			onOpenChange={onOpen}
			fullSize={false}
			title={modalTitle}
		>
			{equipmentModalABTest ? (
				<EquipmentContentV2 upgrade={upgrade} />
			) : (
				<EquipmentContent
					upgrade={upgrade}
					standardEquipmentList={standardEquipmentList}
					comparingTo={comparingTo}
				/>
			)}
		</Modal>
	);
};
